(function () {
  var carousels = document.querySelectorAll('[data-ib-carousel]');

  Array.prototype.forEach.call(carousels, function (carousel) {
    var slides = carousel.querySelectorAll('[data-ib-carousel-slide]');
    var dots = carousel.querySelectorAll('[data-ib-carousel-dot]');
    var previousButton = carousel.querySelector('[data-ib-carousel-previous]');
    var nextButton = carousel.querySelector('[data-ib-carousel-next]');
    var content = carousel.querySelector('[data-ib-hero-content]');
    var slideDataNode = carousel.querySelector('[data-ib-hero-slides]');
    var slideData = [];
    var currentSlide = 0;
    var autoplayTimer = null;

    if (!slides.length) return;

    if (slideDataNode) {
      try {
        slideData = JSON.parse(slideDataNode.textContent);
      } catch (error) {
        slideData = [];
      }
    }

    function setText(selector, value, attribute) {
      if (!content) return;
      var node = content.querySelector(selector);
      if (!node) return;
      if (attribute) {
        node.setAttribute(attribute, value || '');
      } else {
        node.textContent = value || '';
      }
    }

    function restartTypewriter(text) {
      var target = content && content.querySelector('[data-ib-typewriter]');
      var measure = content && content.querySelector('.ib-typewriter__measure');
      if (!target) return;

      target.setAttribute('data-ib-typewriter', text || '');
      target.textContent = '';
      if (measure) measure.textContent = text || '';

      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion) {
        target.textContent = text || '';
        return;
      }

      var index = 0;
      function typeNextCharacter() {
        if (target.getAttribute('data-ib-typewriter') !== text) return;
        index += 1;
        target.textContent = (text || '').slice(0, index);
        if (index < (text || '').length) window.setTimeout(typeNextCharacter, 45);
      }
      window.setTimeout(typeNextCharacter, 100);
    }

    function syncContent(index) {
      if (!slideData[index]) return;
      setText('[data-ib-hero-eyebrow]', slideData[index].eyebrow);
      setText('[data-ib-hero-text]', slideData[index].text);
      setText('[data-ib-hero-primary]', slideData[index].primaryLabel);
      setText('[data-ib-hero-secondary]', slideData[index].secondaryLabel);
      setText('[data-ib-hero-primary]', slideData[index].primaryLink, 'href');
      setText('[data-ib-hero-secondary]', slideData[index].secondaryLink, 'href');
      var heading = content && content.querySelector('[data-ib-hero-heading]');
      if (heading) heading.setAttribute('aria-label', slideData[index].heading || '');
      if (content && content.querySelector('[data-ib-typewriter]')) {
        restartTypewriter(slideData[index].heading);
      } else {
        setText('[data-ib-hero-heading]', slideData[index].heading);
      }
    }

    function showSlide(index) {
      currentSlide = (index + slides.length) % slides.length;

      Array.prototype.forEach.call(slides, function (slide, slideIndex) {
        var active = slideIndex === currentSlide;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      Array.prototype.forEach.call(dots, function (dot, dotIndex) {
        var active = dotIndex === currentSlide;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });

      syncContent(currentSlide);
      startAutoplay();
    }

    function startAutoplay() {
      if (autoplayTimer) window.clearTimeout(autoplayTimer);
      if (carousel.getAttribute('data-ib-autoplay') !== 'true') return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var interval = parseInt(carousel.getAttribute('data-ib-interval'), 10) || 6500;
      autoplayTimer = window.setTimeout(function () {
        showSlide(currentSlide + 1);
      }, interval);
    }

    if (previousButton) {
      previousButton.addEventListener('click', function () {
        showSlide(currentSlide - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        showSlide(currentSlide + 1);
      });
    }

    Array.prototype.forEach.call(dots, function (dot) {
      dot.addEventListener('click', function () {
        showSlide(parseInt(dot.getAttribute('data-ib-carousel-dot'), 10));
      });
    });

    carousel.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') showSlide(currentSlide - 1);
      if (event.key === 'ArrowRight') showSlide(currentSlide + 1);
    });

    startAutoplay();
  });

  var typewriter = document.querySelector('[data-ib-typewriter]');

  if (typewriter) {
    var typewriterText = typewriter.getAttribute('data-ib-typewriter');
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion) {
      typewriter.textContent = typewriterText;
    } else {
      var typewriterIndex = 0;

      function typeNextCharacter() {
        typewriterIndex += 1;
        typewriter.textContent = typewriterText.slice(0, typewriterIndex);
        if (typewriterIndex < typewriterText.length) {
          window.setTimeout(typeNextCharacter, 65);
        }
      }

      window.setTimeout(typeNextCharacter, 450);
    }
  }

  var revealItems = document.querySelectorAll('.ib-section, .ib-program, .ib-lifestyle, .ib-product-card, .ib-look');
  if ('IntersectionObserver' in window && revealItems.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

    Array.prototype.forEach.call(revealItems, function (item) {
      item.classList.add('ib-reveal');
      observer.observe(item);
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-ib-accordion-toggle]');
    if (!toggle) return;

    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    var open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (panel) panel.hidden = open;
  });

  var stickyAtc = document.querySelector('[data-ib-sticky-atc]');
  var productForm = document.querySelector('[data-product-form]');
  if (stickyAtc && productForm && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    stickyObserver.observe(productForm);

    var stickyButton = stickyAtc.querySelector('button');
    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        var submit = productForm.querySelector('[data-add-to-cart]');
        if (submit) submit.click();
      });
    }
  }

  var recentlyViewed = document.querySelector('[data-ib-recently-viewed]');
  if (recentlyViewed && window.localStorage) {
    var key = 'ib_recently_viewed';
    var currentProduct = {
      handle: recentlyViewed.getAttribute('data-product-handle'),
      title: recentlyViewed.getAttribute('data-product-title'),
      url: recentlyViewed.getAttribute('data-product-url'),
      image: recentlyViewed.getAttribute('data-product-image')
    };
    var previous = [];

    try {
      previous = JSON.parse(window.localStorage.getItem(key)) || [];
    } catch (error) {
      previous = [];
    }

    var list = recentlyViewed.querySelector('[data-ib-recently-viewed-list]');
    var itemsToRender = previous.filter(function (item) {
      return item.handle && item.handle !== currentProduct.handle;
    }).slice(0, 6);

    if (itemsToRender.length && list) {
      function escapeHtml(value) {
        return String(value || '').replace(/[&<>"']/g, function (character) {
          return {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
          }[character];
        });
      }

      list.innerHTML = itemsToRender.map(function (item) {
        var title = escapeHtml(item.title);
        var url = escapeHtml(item.url);
        var imageUrl = escapeHtml(item.image);
        var image = imageUrl ? '<img src="' + imageUrl + '" alt="' + title + '" loading="lazy">' : '';
        return '<a class="ib-recent-card" href="' + url + '">' + image + '<span>' + title + '</span></a>';
      }).join('');
      recentlyViewed.hidden = false;
    }

    var next = [currentProduct].concat(previous.filter(function (item) {
      return item.handle !== currentProduct.handle;
    })).slice(0, 8);
    window.localStorage.setItem(key, JSON.stringify(next));
  }

  var header = document.querySelector('[data-ib-header]');
  if (!header) return;

  var mobileMenu = document.querySelector('[data-ib-mobile-menu]');
  var openButton = document.querySelector('[data-ib-menu-open]');
  var closeButton = document.querySelector('[data-ib-menu-close]');

  function syncHeader() {
    if (window.scrollY > 40) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }

  function setMenu(open) {
    header.classList.toggle('is-open', open);
    if (mobileMenu) {
      mobileMenu.classList.toggle('is-open', open);
      mobileMenu.setAttribute('aria-hidden', open ? 'false' : 'true');
    }
    if (openButton) {
      openButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    document.documentElement.classList.toggle('ib-menu-open', open);
  }

  syncHeader();
  window.addEventListener('scroll', syncHeader, { passive: true });

  if (openButton) {
    openButton.addEventListener('click', function () {
      setMenu(true);
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', function () {
      setMenu(false);
    });
  }

  if (mobileMenu) {
    mobileMenu.addEventListener('click', function (event) {
      if (event.target.tagName === 'A') setMenu(false);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setMenu(false);
  });

})();
